import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/sub-comp/Navbar";
import Footer from "../components/sub-comp/MainFooter";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import { FaChevronRight, FaCheck, FaCopy, FaHome, FaInfoCircle, FaUniversity, FaBed, FaCalendarAlt, FaSearch, FaPrint, FaDownload, FaShareAlt } from "react-icons/fa";

const sections = {
  hero: "hero",
  programs: "programs",
  schedule: "schedule",
  sidebar: "sidebar",
  hostel: "hostel",
  payment: "payment",
  contact: "contact",
};

const CURRENCY = "TZS";
const formatAmount = (num) => {
  if (num === "-" || num === null || num === undefined) return "-";
  const n = typeof num === "number" ? num : parseInt(String(num).replace(/[^0-9]/g, ""), 10);
  if (isNaN(n)) return String(num);
  return `${CURRENCY} ${n.toLocaleString("en-US")}`;
};

const highlight = (text, query) => {
  if (!query) return text;
  const parts = String(text).split(new RegExp(`(${query})`, "ig"));
  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={i} className="bg-yellow-300/60 text-black rounded px-0.5">{part}</mark>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};

const mainFeeData = [
  { sno: 1, label: "Tuition Fee", l4: 980000, l5: 975000, l6: 920000 },
  { sno: 2, label: "Examination Fee", l4: 175000, l5: 175000, l6: 205000 },
  { sno: 3, label: "ID Card", l4: 10000, l5: 10000, l6: 10000 },
  { sno: 4, label: "Nacte", l4: 20000, l5: 20000, l6: 20000 },
  { sno: 5, label: "Library Membership", l4: 35000, l5: 35000, l6: 35000 },
  { sno: 6, label: "Academic Activity", l4: 60000, l5: 60000, l6: 60000 },
  { sno: 7, label: "Caution(Nr)", l4: 50000, l5: "-", l6: "-" },
  { sno: 8, label: "IPT/Placement", l4: 45000, l5: 45000, l6: 30000 },
  { sno: 9, label: "Student Union", l4: 5000, l5: 5000, l6: 5000 },
  { sno: 10, label: "Registration Nacte", l4: 20000, l5: "-", l6: "-" },
  { sno: 11, label: "Project", l4: "-", l5: 25000, l6: 25000 },
  { sno: 12, label: "Graduation", l4: "-", l5: "-", l6: 40000 },
];
const totalsRow = { l4: 1400000, l5: 1350000, l6: 1350000 };
// Additional rows retained for future use if needed in expanded details

const otherPaymentsExact = [
  { label: "Certificate Fee", amount: 50000 },
  { label: "Application Form", amount: 20000 },
];


const hostelDetails = { sno: 1, detail: "Hostel Without Meal", amount: 470000 };

const paymentTerms = `All fees should be paid by the 5th of month. Parents and Students must ensure that the fee is paid on time. Failure to disburse the fee before the deadline will result in penalty of 2% per month of the remaining amount until paid. Parents are welcomed to apply for the installment plan in writing prior to the due date. Parents must remain with the invoice and payment receipt at all time during all three years. In case of any audit or misunderstanding on payment, parent will be required to submit the originals as proof of payment to vouch that payment was done as required otherwise full payment will be required.`;

const bankingInstr = `All fees are to be banked and submit deposit slip to the cashier`;

const accountDetails = {
  title: "JR EDUCATIONAL SERVICES LTD",
  banks: [
    { label: "CRDB BANK Account", value: "01J1035181700 (CRDB BANK ARUSHA BRANCH)" },
    { label: "DTB Account", value: "0000535571 (DIAMOND TRUST BANK UHURU BRANCH-ARUSHA)" },
    { label: "Mobile Payment", value: "M-PESA LIPA NUMBER 5591309" },
    { label: "Note", value: "Receipts will be issued only after the cheque has been cleared" },
  ],
};

const contactInfo = {
  phones: ["0754 360 590", "0753 888 221", "0679 414 415"],
};

const foreignRemittance = {
  bank: "Diamond Trust Bank – Uhuru Road",
  name: "JR Educational Services Ltd",
  type: "US $ A/C",
  number: "0000535570",
  correspondent: "Standard Chartered Bank, One Madison Avenue, New York",
  swift: "SCBLUS33",
  aba: "026002561",
  credit: "D T Bank S/c No. 3582-020741-001",
  dtSwift: "DTKETZTZ",
};

const ProgramFeeBlock = ({ title, items, total, expanded, onToggle, query }) => {
  return (
    <div className="relative rounded-3xl p-6 md:p-8 bg-white border border-gray-200 shadow-lg transition-all duration-500">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl md:text-2xl font-bold text-gray-800 tracking-wide flex items-center gap-3">
          <span className="inline-flex w-10 h-10 items-center justify-center rounded-xl bg-custom-pink text-white">$</span>
          {highlight(title, query)}
        </h3>
        <button onClick={onToggle} className="text-sm px-4 py-2 rounded-full bg-gray-100 border border-gray-200 text-gray-700 hover:bg-custom-pink hover:text-white transition-colors">
          {expanded ? "Hide breakdown" : "View breakdown"}
        </button>
      </div>
      <div className="space-y-3">
        {(expanded ? items : items.slice(0, 4)).map((it) => (
          <div key={it.label} className="group flex items-center justify-between rounded-2xl px-4 py-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 transition-colors">
            <div className="flex items-center gap-3">
              <FaCheck className="text-gold opacity-80" />
              <span className="text-gray-700">{highlight(it.label, query)}</span>
            </div>
            <span title="Amount" className="text-gray-800 font-semibold group-hover:scale-[1.03] transition-transform">
              {formatAmount(it.amount)}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-6 text-right text-gray-600">
        <span className="text-sm mr-2">Total:</span>
        <span className="font-bold text-gray-800">{formatAmount(total)}</span>
      </div>
    </div>
  );
};

// Timeline item reserved for future use (custom timeline is rendered inline)

const FloatingSidebar = ({ query, onSearchChange, onClear }) => (
  <aside id={sections.sidebar} className="sticky top-24 space-y-4" aria-label="Other payments">
    <div className="rounded-3xl p-6 bg-white border border-gray-200 shadow-lg">
      <h3 className="text-gray-800 font-bold text-lg mb-4 flex items-center gap-2">
        <FaInfoCircle className="text-gold" /> Other Payments
      </h3>
      <ul className="space-y-3">
        {otherPaymentsExact.map((op) => (
          <li key={op.label} className="flex items-center justify-between text-gray-700 bg-gray-50 rounded-xl px-4 py-2 border border-gray-200">
            <span>{highlight(op.label, query)}</span>
            <span className="font-semibold">{formatAmount(op.amount)}</span>
          </li>
        ))}
      </ul>
    </div>

    <div className="rounded-3xl p-6 bg-white border border-gray-200 shadow-lg">
      <h4 className="text-gray-800 font-bold mb-3 flex items-center gap-2">
        <FaSearch className="text-gold" /> Quick Filter
      </h4>
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={query}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search fees, programs, schedule..."
          className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gold"
        />
        {query && (
          <button onClick={onClear} className="px-3 py-2 rounded-lg bg-gray-100 border border-gray-200 text-gray-700 hover:bg-gray-200">Clear</button>
        )}
      </div>
    </div>
  </aside>
);

const FeeStructure = () => {
  const [copied, setCopied] = useState(false);
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState({ l4: false, l5: false, l6: false });
  const [active, setActive] = useState(sections.hero);
  const [schedulePulse, setSchedulePulse] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [shareOpen, setShareOpen] = useState(false); // reserved for a full share modal implementation
  const parallaxRef = useRef(null);
  const programsRef = useRef(null);
  const scheduleRef = useRef(null);
  const sidebarRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (!parallaxRef.current) return;
      const y = window.scrollY;
      parallaxRef.current.style.transform = `translateY(${y * 0.15}px)`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Observe sections to toggle active quick link state
  useEffect(() => {
    const opts = { root: null, rootMargin: "0px", threshold: 0.35 };
    const map = new Map([
      [sections.programs, programsRef],
      [sections.schedule, scheduleRef],
      [sections.sidebar, sidebarRef],
    ]);
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, opts);
    map.forEach((ref) => ref.current && obs.observe(ref.current));
    return () => obs.disconnect();
  }, []);

  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {}
  };

  const handlePrint = () => window.print();
  const handleDownload = async () => {
    // Attempt to use html2pdf.js, fallback to print
    const ensureLib = () =>
      new Promise((resolve, reject) => {
        if (window.html2pdf) return resolve(true);
        const s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
        s.onload = () => resolve(true);
        s.onerror = reject;
        document.body.appendChild(s);
      });
    try {
      await ensureLib();
      const target = document.getElementById("fee-structure-print-area");
      const opt = {
        margin: 10,
        filename: "JR_Institute_Fee_Structure_2025-2026.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"], avoid: [".avoid-break"] },
      };
      window.html2pdf().from(target).set(opt).save();
    } catch (_) {
      window.print();
    }
  };
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: "JRIIT Fee Structure", url: window.location.href });
      } else {
        await copyText(window.location.href);
      }
    } catch (_) {}
  };

  // Smooth scroll helper (800ms)
  const scrollToSmooth = (el) => {
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.pageYOffset - 100;
    const start = window.pageYOffset;
    const distance = top - start;
    const duration = 800;
    let startTime = null;
    const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const time = Math.min(1, (currentTime - startTime) / duration);
      const eased = easeInOutQuad(time);
      window.scrollTo(0, start + distance * eased);
      if (time < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  };

  const gotoPrograms = () => scrollToSmooth(programsRef.current);
  const gotoSchedule = () => { scrollToSmooth(scheduleRef.current); setSchedulePulse(true); setTimeout(()=>setSchedulePulse(false), 1200); };
  const gotoOtherPayments = () => { setSidebarOpen(true); scrollToSmooth(sidebarRef.current); };

  const programFromTable = (key, title) => {
    const mapKey = { l4: "l4", l5: "l5", l6: "l6" }[key];
    const items = mainFeeData.map((r) => ({ label: r.label, amount: r[mapKey] }));
    const total = totalsRow[key];
    return { title, items, total };
  };

  const l4 = programFromTable("l4", "Certificate NTA L4");
  const l5 = programFromTable("l5", "Technician Certificate NTA L5");
  const l6 = programFromTable("l6", "Diploma NTA L6");

  const phoneLinks = contactInfo.phones.map((p) => ({ raw: p, href: `tel:${p.replace(/\s/g, "")}` }));

  return (
    <>
    <Navbar />
    <div className="min-h-screen bg-white text-gray-800 relative overflow-hidden">

      {/* Parallax floating accents */}
      <div ref={parallaxRef} className="pointer-events-none select-none">
        <div className="absolute -top-24 -left-24 w-[32rem] h-[32rem] rounded-full bg-custom-pink/20 blur-3xl" />
        <div className="absolute top-[40rem] -right-24 w-[28rem] h-[28rem] rounded-full bg-gold/10 blur-3xl" />
      </div>

      {/* Hero */}
      <section id={sections.hero} className="relative pt-28 pb-16 md:pt-32 md:pb-24">
        <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />
        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center text-sm text-gray-600 gap-2 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-gold flex items-center gap-2"><FaHome /> Home</Link>
            <FaChevronRight className="opacity-60" />
            <span className="text-gold">Fee Structure</span>
          </nav>

          <div className="max-w-4xl">
            <h1 className="text-3xl md:text-6xl font-extrabold tracking-tight leading-tight text-gray-800">
              2025–2026 <span className="text-gold">FEE STRUCTURE</span>
            </h1>
            <p className="mt-4 text-gray-600 text-lg md:text-xl">
              Explore program fees, payment timelines, hostel details, and official payment instructions.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 no-print">
              <button onClick={gotoPrograms} className={`text-sm px-4 py-2 rounded-full border transition-colors ${active===sections.programs?"bg-custom-pink text-white border-custom-pink":"bg-gray-100 text-gray-700 border-gray-200 hover:bg-custom-pink hover:text-white"}`}>Programs</button>
              <button onClick={gotoSchedule} className={`text-sm px-4 py-2 rounded-full border transition-colors ${active===sections.schedule?"bg-custom-pink text-white border-custom-pink":"bg-gray-100 text-gray-700 border-gray-200 hover:bg-custom-pink hover:text-white"}`}>Schedule</button>
              <button onClick={gotoOtherPayments} className={`text-sm px-4 py-2 rounded-full border transition-colors ${active===sections.sidebar?"bg-custom-pink text-white border-custom-pink":"bg-gray-100 text-gray-700 border-gray-200 hover:bg-custom-pink hover:text-white"}`}>Other Payments</button>
              <a href="#hostel" className={`text-sm px-4 py-2 rounded-full border transition-colors ${active===sections.hostel?"bg-custom-pink text-white border-custom-pink":"bg-gray-100 text-gray-700 border-gray-200 hover:bg-custom-pink hover:text-white"}`}>Hostel</a>
              <a href="#payment" className={`text-sm px-4 py-2 rounded-full border transition-colors ${active===sections.payment?"bg-custom-pink text-white border-custom-pink":"bg-gray-100 text-gray-700 border-gray-200 hover:bg-custom-pink hover:text-white"}`}>Payment</a>
            </div>
            <div className="mt-6 flex flex-wrap gap-3 no-print">
              <button onClick={handlePrint} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold text-white border border-gold hover:bg-yellow-500"><FaPrint /> Print</button>
              <button onClick={handleDownload} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-custom-pink text-white border border-custom-pink hover:bg-purple-600"><FaDownload /> Download PDF</button>
              <button onClick={handleShare} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 text-gray-700 border border-gray-200 hover:bg-gray-200"><FaShareAlt /> Share</button>
            </div>
          </div>
        </div>
        <svg className="w-full h-16 md:h-24 text-white" preserveAspectRatio="none" viewBox="0 0 100 100"><polygon fill="currentColor" points="0,100 100,0 100,100" /></svg>
      </section>

      {/* Main content */}
      <section className="relative" id={sections.programs} ref={programsRef}>
        <div className="container mx-auto px-4" id="fee-structure-print-area">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-3 space-y-8">
              {/* Program blocks from main table data with breakdown toggle */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="transform md:-rotate-1 md:hover:rotate-0 transition-transform">
                  <ProgramFeeBlock
                    title={l4.title}
                    items={l4.items}
                    total={l4.total}
                    expanded={expanded.l4}
                    onToggle={() => setExpanded((s) => ({ ...s, l4: !s.l4 }))}
                    query={query}
                  />
                </div>
                <div className="transform md:rotate-1 md:hover:rotate-0 transition-transform">
                  <ProgramFeeBlock
                    title={l5.title}
                    items={l5.items}
                    total={l5.total}
                    expanded={expanded.l5}
                    onToggle={() => setExpanded((s) => ({ ...s, l5: !s.l5 }))}
                    query={query}
                  />
                </div>
                <div className="transform md:-rotate-2 md:hover:rotate-0 transition-transform">
                  <ProgramFeeBlock
                    title={l6.title}
                    items={l6.items}
                    total={l6.total}
                    expanded={expanded.l6}
                    onToggle={() => setExpanded((s) => ({ ...s, l6: !s.l6 }))}
                    query={query}
                  />
                </div>
              </div>

              {/* Payment schedule - Simplified */}
              <section id={sections.schedule} className="mt-4" ref={scheduleRef}>
                <div className={`rounded-3xl p-6 md:p-10 bg-white border border-gray-200 shadow-lg transition-shadow ${schedulePulse?"ring-2 ring-gold shadow-[0_0_0_6px_rgba(252,169,3,0.15)]":""}`}>
                  <h3 className="text-2xl font-bold text-gray-800 flex items-center gap-3 mb-2"><FaCalendarAlt className="text-gold" /> Payment Schedule</h3>
                  <p className="text-gray-600 mb-6">Simple payment plans for each program level.</p>
                  
                  {/* Simplified Payment Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* NTA Level 4 */}
                    <div className="bg-gradient-to-br from-custom-pink/10 to-purple-100 rounded-2xl p-6 border border-custom-pink/20">
                      <h4 className="text-lg font-bold text-gray-800 mb-4">NTA Level 4 (Certificate)</h4>
                      <div className="space-y-3">
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">March Intake</span>
                          <span className="font-semibold text-gray-800">TZS 380,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">June Payment</span>
                          <span className="font-semibold text-gray-800">TZS 340,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">September Payment</span>
                          <span className="font-semibold text-gray-800">TZS 340,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2">
                          <span className="text-gray-600">December Payment</span>
                          <span className="font-semibold text-gray-800">TZS 340,000</span>
                        </div>
                        <div className="mt-4 pt-3 border-t-2 border-custom-pink">
                          <div className="flex justify-between items-center">
                            <span className="font-bold text-gray-800">Total</span>
                            <span className="font-bold text-custom-pink text-lg">TZS 1,400,000</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* NTA Level 5 */}
                    <div className="bg-gradient-to-br from-gold/10 to-yellow-100 rounded-2xl p-6 border border-gold/20">
                      <h4 className="text-lg font-bold text-gray-800 mb-4">NTA Level 5 (Technician)</h4>
                      <div className="space-y-3">
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">March Intake</span>
                          <span className="font-semibold text-gray-800">TZS 360,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">July Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">October Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2">
                          <span className="text-gray-600">February Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="mt-4 pt-3 border-t-2 border-gold">
                          <div className="flex justify-between items-center">
                            <span className="font-bold text-gray-800">Total</span>
                            <span className="font-bold text-gold text-lg">TZS 1,350,000</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* NTA Level 6 */}
                    <div className="bg-gradient-to-br from-indigo-100 to-blue-100 rounded-2xl p-6 border border-indigo-200">
                      <h4 className="text-lg font-bold text-gray-800 mb-4">NTA Level 6 (Diploma)</h4>
                      <div className="space-y-3">
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">April Intake</span>
                          <span className="font-semibold text-gray-800">TZS 360,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">July Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                          <span className="text-gray-600">October Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="flex justify-between items-center py-2">
                          <span className="text-gray-600">February Payment</span>
                          <span className="font-semibold text-gray-800">TZS 330,000</span>
                        </div>
                        <div className="mt-4 pt-3 border-t-2 border-indigo-500">
                          <div className="flex justify-between items-center">
                            <span className="font-bold text-gray-800">Total</span>
                            <span className="font-bold text-indigo-600 text-lg">TZS 1,350,000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Important Notes */}
                  <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                    <h5 className="font-bold text-yellow-800 mb-2">📋 Important Payment Information</h5>
                    <ul className="text-yellow-700 space-y-1 text-sm">
                      <li>• All payments must be made by the 5th of each month</li>
                      <li>• Late payments incur a 2% penalty per month</li>
                      <li>• Installment plans available upon written request</li>
                      <li>• Keep all payment receipts for your records</li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Hostel details */}
              <section id={sections.hostel} className="relative">
                <div className="rounded-3xl p-6 md:p-8 bg-white border border-gray-200 shadow-lg">
                  <h3 className="text-2xl font-bold text-gray-800 flex items-center gap-3 mb-4"><FaBed className="text-gold" /> Hostel Details</h3>
                  <div className="space-y-3 text-gray-600">
                    <div className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
                      <div className="flex items-center gap-3">
                        <span className="text-gray-500">S/NO: {hostelDetails.sno}</span>
                        <span className="font-semibold text-gray-800">{highlight(hostelDetails.detail, query)}</span>
                      </div>
                      <span className="font-semibold text-gray-800">{formatAmount(hostelDetails.amount)}<span className="text-gray-500 text-xs"> / academic year</span></span>
                    </div>
                  </div>
                </div>
              </section>

              {/* Payment instructions + bank details */}
              <section id={sections.payment} className="relative">
                <div className="rounded-3xl p-6 md:p-8 bg-white border border-gray-200 shadow-lg">
                  <h3 className="text-2xl font-bold text-gray-800 flex items-center gap-3 mb-4"><FaUniversity className="text-gold" /> Payment Instructions</h3>
                  <p className="text-gray-600 mb-4">{bankingInstr}</p>
                  <p className="text-gray-600 whitespace-pre-line">{paymentTerms}</p>

                  <div className="mt-6 rounded-2xl p-4 bg-gray-50 border border-gray-200">
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <p className="text-gray-800 font-bold">{accountDetails.title}</p>
                        {accountDetails.banks.map((b) => (
                          <p key={b.label} className="text-gray-600"><span className="font-semibold">{b.label}:</span> {b.value}</p>
                        ))}
                      </div>
                      <button onClick={() => copyText(`${accountDetails.title}\n${accountDetails.banks.map(b=>`${b.label}: ${b.value}`).join("\n")}`)} className="shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-custom-pink text-white border border-custom-pink hover:bg-purple-600 transition-colors"><FaCopy /> {copied ? "Copied!" : "Copy"}</button>
                    </div>
                  </div>

                  <div className="mt-6 rounded-2xl p-4 bg-gray-50 border border-gray-200">
                    <h4 className="font-semibold mb-2 text-gray-800">Foreign Remittance Details</h4>
                    <div className="grid sm:grid-cols-2 gap-2 text-gray-600">
                      <p><span className="font-semibold">Bank:</span> {foreignRemittance.bank}</p>
                      <p><span className="font-semibold">Account Name:</span> {foreignRemittance.name}</p>
                      <p><span className="font-semibold">Account Type:</span> {foreignRemittance.type}</p>
                      <p><span className="font-semibold">Account #:</span> {foreignRemittance.number}</p>
                      <p><span className="font-semibold">Correspondent Bank:</span> {foreignRemittance.correspondent}</p>
                      <p><span className="font-semibold">SWIFT:</span> {foreignRemittance.swift}</p>
                      <p><span className="font-semibold">ABA Number:</span> {foreignRemittance.aba}</p>
                      <p><span className="font-semibold">For Credit of USD:</span> {foreignRemittance.credit}</p>
                      <p><span className="font-semibold">D T Bank Swift:</span> {foreignRemittance.dtSwift}</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            {/* Floating sidebar */}
            <div className="lg:col-span-1" ref={sidebarRef}>
              <div className={`transition-transform duration-500 ${sidebarOpen?"translate-x-0":"translate-x-96 lg:translate-x-0"}`}>
                <FloatingSidebar query={query} onSearchChange={setQuery} onClear={() => setQuery("")} />
              </div>
              <div className="mt-3 lg:hidden no-print">
                <button onClick={()=>setSidebarOpen((o)=>!o)} className="w-full px-4 py-2 rounded-xl bg-custom-pink text-white border border-custom-pink hover:bg-purple-600">{sidebarOpen?"Hide Other Payments":"Show Other Payments"}</button>
              </div>
            </div>
          </div>
        </div>
        <svg className="mt-16 w-full h-16 md:h-24 text-white rotate-180" preserveAspectRatio="none" viewBox="0 0 100 100"><polygon fill="currentColor" points="0,100 100,0 100,100" /></svg>
      </section>

      {/* Contact footer */}
      <section id={sections.contact} className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="rounded-3xl p-6 md:p-10 bg-white border border-gray-200 shadow-lg">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-800">Need assistance?</h3>
                <p className="text-gray-600 mt-2">Contact our admissions and finance teams for any questions about fees and payments.</p>
                <div className="mt-3 flex flex-wrap gap-3">
                  {phoneLinks.map((ph) => (
                    <a key={ph.href} href={ph.href} className="underline text-gold hover:opacity-90">{ph.raw}</a>
                  ))}
                </div>
              </div>
              <div className="flex flex-wrap gap-3 no-print">
                <Link to="/contact" className="px-6 py-3 rounded-full bg-gold text-black font-semibold hover:brightness-110 transition">Contact Us</Link>
                <a href="#hero" className="px-6 py-3 rounded-full bg-custom-pink text-white border border-custom-pink hover:bg-purple-600 transition">Back to top</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Desktop Share Modal */}
      {shareOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 no-print" role="dialog" aria-modal="true">
          <div className="w-full max-w-sm rounded-2xl bg-[#111827] border border-white/10 p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-white font-semibold">Share Fee Structure</h4>
              <button onClick={()=>setShareOpen(false)} className="text-white/70 hover:text-white">✕</button>
            </div>
            <div className="space-y-3">
              <button onClick={()=>copyText(window.location.href)} className="w-full text-left px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white hover:bg-white/20">Copy Link</button>
              <a href={`mailto:?subject=JRIIT Fee Structure&body=${encodeURIComponent(window.location.href)}`} className="block px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white hover:bg-white/20">Share via Email</a>
              <a href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noreferrer" className="block px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white hover:bg-white/20">Share via WhatsApp</a>
            </div>
            <div className="mt-4 text-right">
              <button onClick={()=>setShareOpen(false)} className="px-4 py-2 rounded-full bg-white/10 border border-white/10 text-white hover:bg-white/20">Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Print styles */}
      <style>{`
        @media print {
          .no-print { display: none !important; }
          header, nav { display: none !important; }
          body { background: #ffffff !important; }
          #fee-structure-print-area { page-break-inside: avoid; }
        }
      `}</style>

      <Footer />
      <FloatingSocialPanels />
    </div>
    </>
  );
};

export default FeeStructure;
